import DashboardAlerts from '@/components/announcements/DashboardAlerts';
import { DashboardDemoInvitation } from '@/components/demo-invitation/DashboardDemoInvitation';
import { AnnouncementBanner } from '@/components/ui/announcement-banner';
import { PortraitCluster } from '@/components/companion/PortraitCluster';
import { useCurrentBrandQuery } from '@/hooks/queries/use-current-brand-query';
import {
  useCompanionOnboardingActions,
  useCompanionOnboardingStatus,
} from '@/hooks/use-companion-onboarding-status';
import { DashboardStatsGrid } from '@/pages/dashboard/_components/DashboardStatsGrid';
import { DashboardDecisionStrip } from '@/pages/dashboard/_components/decisions/DashboardDecisionStrip';
import { DashboardTodoCard } from '@/pages/dashboard/_components/todo';
import { PlanChoiceGate } from '@/pages/dashboard/_components/plan-choice/PlanChoiceGate';
import { Heading, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from './Dashboard.Layout';

const DashboardContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Heading as="h1" size="2xl">
        {t('navigation.dashboard')}
      </Heading>

      <DashboardDecisionStrip />

      <DashboardStatsGrid aside={<DashboardTodoCard />} />
    </>
  );
};

export default function DashboardPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: brand } = useCurrentBrandQuery();
  const { shouldShowBanner } = useCompanionOnboardingStatus(brand?.id);
  const { dismissBanner } = useCompanionOnboardingActions();

  return (
    <DashboardLayout>
      <VStack gap={6} alignItems="stretch">
        <DashboardAlerts />

        <DashboardDemoInvitation />

        {shouldShowBanner && (
          <AnnouncementBanner
            backgroundImage="/images/companion/companion-banner-aura.webp"
            tone="light"
            title={t('companion.banner.title')}
            description={t('companion.banner.description')}
            actionLabel={t('companion.banner.cta')}
            onAction={() => navigate('/onboarding/companion?step=creators')}
            onClose={() => {
              if (brand?.id) {
                dismissBanner(brand.id);
              }
            }}
            endSlot={<PortraitCluster />}
          />
        )}

        <DashboardContent />
      </VStack>

      <PlanChoiceGate />
    </DashboardLayout>
  );
}
